import Decimal from 'decimal.js';
import { utils } from '~/utils';
import { DiscountDTOType, DiscountModel } from '../DiscountModel';
import { PriceIncreaseModel, PriceIncreaseType } from '../PriceIncreaseModel';
import { makeFixedCost, makeRangeCost, makeVariableCost } from './makers';
import { ServiceCostType } from './model';
import * as selectors from './selectors';
export function fromDTO(cost) {
    const discount = DiscountModel.fromDTO(cost.discount);
    const priceIncrease = PriceIncreaseModel.fromDTO(cost.priceIncrease);
    switch(cost.pricingType){
        case ServiceCostType.Fixed:
            return makeFixedCost(cost.price, {
                discount,
                priceIncrease
            });
        case ServiceCostType.Variable:
            return makeVariableCost(cost.price, {
                discount,
                unitCap: cost.unitCapStr != null ? new Decimal(cost.unitCapStr.replace(/,/g, '')) : null,
                unitName: cost.unitName,
                priceIncrease
            });
        case ServiceCostType.Range:
            return makeRangeCost(cost.maxPrice, {
                discount,
                minPrice: cost.minPrice,
                priceIncrease
            });
    }
}
export function effectiveDiscountForWire(cost) {
    return cost.discount || cost.expiredDiscount;
}
export function toDTO(param) {
    let { cost, shouldResetDiscount } = param;
    const discount = getDiscountForDTO(effectiveDiscountForWire(cost), shouldResetDiscount);
    const priceIncrease = cost.priceIncrease.toDTO();
    return selectors.match(cost, {
        fixed: (fixed)=>({
                pricingType: fixed.pricingType,
                price: fixed.price.toNumber(),
                discount,
                priceIncrease
            }),
        range: (range)=>({
                pricingType: range.pricingType,
                minPrice: range.minPrice ? range.minPrice.toNumber() : null,
                maxPrice: range.maxPrice.toNumber(),
                discount,
                priceIncrease
            }),
        variable: (variable)=>({
                pricingType: variable.pricingType,
                unitName: variable.unitName,
                price: variable.price.toNumber(),
                unitCapStr: variable.unitCap ? variable.unitCap.toDP(2).toString() : null,
                discount,
                priceIncrease
            })
    });
}
export function getDiscountForDTO(originalDiscount, shouldReset) {
    if (shouldReset) return {
        type: DiscountDTOType.None
    };
    return (originalDiscount === null || originalDiscount === void 0 ? void 0 : originalDiscount.toDTO()) || {
        type: DiscountDTOType.None
    };
}
export function fromDBDTO(cost) {
    const discount = cost.discount && DiscountModel.fromDBDTO(cost.discount);
    if (cost.pricingType.type === ServiceCostType.Fixed) {
        return makeFixedCost(utils.centsToDollars(cost.pricingType.fixed.price), {
            discount
        });
    } else if (cost.pricingType.type === ServiceCostType.Variable) {
        return makeVariableCost(utils.centsToDollars(cost.pricingType.variable.unitPrice), {
            discount,
            unitCap: cost.pricingType.variable.cap != null ? utils.centsToDollars(cost.pricingType.variable.cap) : null,
            unitName: cost.pricingType.variable.name
        });
    } else {
        return makeRangeCost(utils.centsToDollars(cost.pricingType.range.maxPrice), {
            discount,
            minPrice: cost.pricingType.range.minPrice != null ? utils.centsToDollars(cost.pricingType.range.minPrice) : null
        });
    }
}
export function toDBDTO(cost) {
    const discount = getDiscountForDB(cost.discount);
    const priceIncrease = {
        type: PriceIncreaseType.None
    };
    return selectors.match(cost, {
        fixed: (fixed)=>({
                discount,
                priceIncrease,
                pricingType: {
                    type: ServiceCostType.Fixed,
                    fixed: {
                        price: utils.dollarsToCents(fixed.price)
                    },
                    variable: null,
                    range: null
                }
            }),
        variable: (variable)=>({
                discount,
                priceIncrease,
                pricingType: {
                    type: ServiceCostType.Variable,
                    fixed: null,
                    variable: {
                        unitPrice: utils.dollarsToCents(variable.price),
                        cap: variable.unitCap != null ? utils.dollarsToCents(variable.unitCap) : null,
                        name: variable.unitName
                    },
                    range: null
                }
            }),
        range: (range)=>({
                discount,
                priceIncrease,
                pricingType: {
                    type: ServiceCostType.Range,
                    fixed: null,
                    variable: null,
                    range: {
                        minPrice: range.minPrice != null ? utils.dollarsToCents(range.minPrice) : null,
                        maxPrice: utils.dollarsToCents(range.maxPrice)
                    }
                }
            })
    });
}
export function getDiscountForDB(discount) {
    if (!discount) {
        return {
            type: DiscountDTOType.None
        };
    }
    return discount.toDBDTO();
}
